import { createOutlineIcon } from "../createIcon";

export const MuteOutlineIcon = createOutlineIcon(
  <>
    <path d="M17.1957 8.0625V3L12.2123 8.23261L5 8.23261V15.7667H9.33483M17.1957 13.125V21L13.0357 16.632M5.53571 19.3125L9.33483 15.7667M20 5.8125L9.33483 15.7667" />
  </>,
  "MuteOutlineIcon"
);
